import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useResetBranchGovernmentAllocationDistributions } from '@/features/privateCompanies/hooks/useResetBranchGovernmentAllocationDistributions'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

interface BranchGovernmentAllocationDistributionsResetModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  governmentAllocationId?: string
  branchId: string
}

export const BranchGovernmentAllocationDistributionsResetModal = ({
  isOpen,
  setIsOpen,
  governmentAllocationId,
  branchId
}: BranchGovernmentAllocationDistributionsResetModalProps) => {
  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsBranchesToDistribute'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsAllowedCategoriesAndProducts'] })
  }

  const { mutate: resetDistribution, isPending: resetDistributionIsPending } =
    useResetBranchGovernmentAllocationDistributions({
      branchId,
      onSuccess,
      onError: (error) => {
        setIsOpen(false)
        FormTransformers.errorsTransformer({ setMessages })(error)
      },
    })

  return (
    <>
      <Modal
        triggerAsChild
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Zerar distribuição"
        disabled={resetDistributionIsPending}
        confirmButtonIsLoading={resetDistributionIsPending}
        onConfirm={() => resetDistribution(governmentAllocationId)}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
